import axios from "axios";
import buildUrl from "build-url-ts";

const ASSETS_API_URL = `${process.env.REACT_APP_ASSETS_API_URL}/assets/3.0`;

export interface LinkedInPostCount {
  posted: number;
  scheduled: number;
}

export const linkedInApi = {
  fetchPostCount: async (assetId: string): Promise<LinkedInPostCount> => {
    const url = buildUrl(`${ASSETS_API_URL}/${assetId}/linkedin-post-count`);
    const response = await axios.get(url);
    return response.data;
  }
};
